<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />
    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Search Box -->
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-site-select
              ref="siteSelect"
              :pageId="this.$options.name"
              :selected="frame0.selectData.COD_SITE"
              :disabled="siteDisabled"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="locationName"
              v-model="frame0.locationName"
              maxlength="50"
              @keyup.enter="onClickSearch"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_gridTop_wrap">
        <div
          class="totalList"
          style="padding:3px 12px 0 0"
        >
          {{ totalCount }}
        </div>
        <div class="btn_wrapL">
          <!-- <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickExpand"
          >
            {{ $t("MSG_BTN_ALL_SPREAD") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickCollapse"
          >
            {{ $t("MSG_BTN_ALL_FOLD") }}
          </sui-button> -->
          <sui-button
            type="button"
            :class="expandAll ? 'comm_btn_treeOpen' : 'comm_btn_treeClose'"
            @click="onTreeGridCollapseToggle"
          />
        </div>
      </div>
      <sui-simple-tree
        ref="tree"
        :dataset="'dsLocation'"
        style="height:250px; overflow-y:auto"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickClose"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          v-if="pageInitialData.readonly"
          type="button"
          class="comm_btn_solid"
          @click="onClickSave"
        >
          {{ $t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
    <sui-popup
      v-model="isShownPopup"
      :title="popupTitle"
    >
      <p01
        :pageId="this.$options.name"
        :data="buildingData"
        @onSetFocus="onSetFocus"
        @onClickClose="onClickPopupClose()"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMY_00008_P01';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMY_00008', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default: () => ({
        readonly: false,
        siteDisabled: false,
        siteId: '',
      }),
    },
  },
  data() {
    return {
      dataloaded: false,
      expandAll: true,
      frame0: {
        selectData: {
          COD_SITE: {
            key: '',
            label: '',
          },
        },
        locationName: '',
      },
      // Codes
      COD_PAGE_UE: {
        label: '',
        key: '',
      },
      localdata1: [],
      buildingData: [],
      totalCount: utils.strFormat(this.$t('MSG_TXT_LST_CNT'), 0),
      showCheckbox: true,
      isShownPopup: false,
      popupTitle: this.$t('MSG_TIT_LCT_SELT'),
    };
  },
  computed: {
    siteDisabled() {
      if (!_.isBoolean(this.pageInitialData.siteDisabled)) {
        return false;
      }
      return this.pageInitialData.siteDisabled;
    },
  },
  watch: {},
  datasets: [{
    id: 'dsLocation',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'value', type: 'string', map: 'value' },
      { name: 'text', type: 'string', map: 'text' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'parentsId', type: 'string', map: 'parentsId' },
      { name: 'originalFinalModificationDTM', type: 'string', map: 'originalFinalModificationDTM' },
      { name: 'locationUseYn', type: 'string', map: 'locationUseYn' },
      { name: 'locationTypeCode', type: 'string', map: 'locationTypeCode' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'finalModificationProgramId', type: 'string', map: 'finalModificationProgramId' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationProgramId', type: 'string', map: 'firstRegistrationProgramId' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'businessSectorDivisionCode', type: 'string', map: 'businessSectorDivisionCode' },
      { name: 'floorId', type: 'string', map: 'floorId' },
      { name: 'folderYn', type: 'string', map: 'folderYn' },
      { name: 'headquarterLocationId', type: 'string', map: 'headquarterLocationId' },
      { name: 'id', type: 'string', map: 'id' },
      { name: 'jobDistrictId', type: 'string', map: 'jobDistrictId' },
      { name: 'level', type: 'string', map: 'level' },
      { name: 'selectable', type: 'boolean', map: 'selectable' },
      { name: 'locationEnglishName', type: 'string', map: 'locationEnglishName' },
      { name: 'locationId', type: 'string', map: 'locationId' },
      { name: 'locationName', type: 'string', map: 'locationName' },
      { name: 'locationNoteContent', type: 'string', map: 'locationNoteContent' },
      { name: 'buildingId', type: 'string', map: 'buildingId' },
      { name: 'headquarterSiteId', type: 'string', map: 'headquarterSiteId' },
    ],
    keymap: {
      id: 'id',
      parentid: 'parentsId',
      label: 'text',
      text: 'text',
      value: 'value',
    },
  }],
  created() {
    this.treeData = [];
  },
  mounted() {
    this.$nextTick(() => {
      this.setSiteId();
      this.pageOptionSet();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setSiteId() {
      // 사용자 세션 사업장 코드 값 설정
      const sessionSiteId = this.$store.getters.userInfo.siteId;

      if (utils.isUndefined(this.pageInitialData.siteId)
        || utils.isEmpty(this.pageInitialData.siteId)) {
        this.frame0.selectData.COD_SITE.key = sessionSiteId;
      } else {
        this.frame0.selectData.COD_SITE.key = this.pageInitialData.siteId;
      }
    },
    pageOptionSet() {
      if (this.pageInitialData.readonly) {
        this.showCheckbox = utils.isUndefined(this.pageInitialData.onlyFloorSelection)
          ? false
          : this.pageInitialData.onlyFloorSelection;
      } else {
        this.showCheckbox = this.pageInitialData.readonly;
      }
      if (this.pageInitialData.searchWord) {
        this.frame0.locationName = this.pageInitialData.searchWord;
      }

      this.onClickSearch();
    },
    onClickSearch() {
      const onlyFloorSelection = utils.isUndefined(this.pageInitialData.onlyFloorSelection)
        ? false
        : this.pageInitialData.onlyFloorSelection;
      const queryParams = {
        locationName: this.frame0.locationName,
        siteId: this.frame0.selectData.COD_SITE.key,
        onlyFloorSelection,
      };

      http.request(this.$options.name, 'DTS_CMY_00011', {
        query: queryParams,
      }).then(res => {
        // this.buildingData = utils.clone(res.data);
        const buildingData = [];
        utils.forEach(res.data, row => {
          if (row.level.trim() === '2') {
            buildingData.push(row);
          }
        });

        utils.dateformatToClientInArray(res.data, dateFields);
        this.dsLocation.setRawData(res.data, { preventBackup: true });

        // 총 개수
        this.totalCount = utils.strFormat(this.$t('MSG_TXT_LST_CNT'), res.data.length);

        // 트리 데이터 생성
        // this.createdTreeData();

        // 건물(level2) 데이터만 추출
        // utils.remove(this.buildingData, index => !utils.isEqual(utils.trim(index.level), '2'));
        Object.preventExtensions(buildingData);
        this.buildingData = buildingData;

        if (buildingData.length > 1 && !utils.isEmpty(this.frame0.locationName)) {
          this.isShownPopup = true;
        }

        // 전체접기/펼치기 버튼 초기화
        this.expandAll = utils.isEmpty(this.frame0.locationName);
      });
    },
    createdTreeData() {
      // const newData = [];
      // utils.forEach(this.dsLocation.data, row => {
      //   newData.push({
      //     id: row.id,
      //     parentid: row.parentsId ? row.parentsId : -1,
      //     label: row.text,
      //     text: row.text,
      //     value: row.value,
      //   });
      // });

      // const keyMap = {
      //   id: 'id',
      //   parentid: 'parentsId',
      //   text: 'text',
      //   value: 'value',
      // }

      // this.$refs.tree.setData(this.dsLocation.data, keyMap);

      // const source = {
      //   datatype: 'json',
      //   datafields: [
      //     { name: 'id' },
      //     { name: 'parentid' },
      //     { name: 'label' },
      //     { name: 'text' },
      //     { name: 'value' },
      //   ],
      //   id: 'id',
      //   localdata: newData,
      // };
      // const dataAdapter = new jqx.dataAdapter(source);
      // dataAdapter.dataBind();
      // const records = dataAdapter.getRecordsHierarchy('id', 'parentid', 'items', []);
      // this.$refs.tree.setSource(records);
    },
    onKeyUpInput() {
      const searchFieldNewText = this.frame0.locationName;

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR_SRCH'), this.$t('MSG_ALT_SPECL_CHAR_LIST'), () => {
          this.frame0.locationName = this.searchFieldOldText;
          this.$refs.locationName.setFocus();
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
    onClickSave() {
      const onlyFloorSelection = utils.isUndefined(this.pageInitialData.onlyFloorSelection)
        ? false
        : this.pageInitialData.onlyFloorSelection;
      const selectedItem = this.$refs.tree.getSelectedItem();
      if (selectedItem) {
        const rows = this.dsLocation.data;
        let targetRow = null;
        for (let i = 0; i < rows.length; i += 1) {
          if (selectedItem.id === rows[i].id && (onlyFloorSelection ? rows[i].level === '3' : true)) {
            targetRow = rows[i];
            break;
          }
        }
        if (targetRow) {
          this.closePagePopup(targetRow);
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        }
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickClose() {
      this.closePagePopup('');
    },
    onClickPopupClose() {
      this.isShownPopup = false;
    },
    onSetFocus(id) {
      this.isShownPopup = false;
      this.$refs.tree.reveal(id);
    },
    onClickReset() {
      this.frame0.locationName = '';
      this.searchFieldOldText = '';

      this.setSiteId();
    },
    onTreeGridCollapseToggle() {
      if (this.$refs.tree) {
        if (this.expandAll) {
          this.$refs.tree.expandAll();
        } else {
          this.$refs.tree.collapseAll();
        }
      }
      this.expandAll = !this.expandAll;
    },
  },
};
</script>
<style scoped>
</style>
